import React from 'react';
import styled from 'styled-components';

import { media } from '@prisjakt/ui-base';
import { useAppContext } from '@prisjakt/ui-app-context';
import { UXFeedbackPrompt } from 'src/components/ux-feedback';

import { useLocalStorage } from 'src/hooks/use-localstorage';
import { useShowFeedback } from 'src/hooks/use-show-feedback';

export const ProductPageFeedback = () => {
  const { market, t } = useAppContext();

  const [productPageUXFeedbackTime] = useLocalStorage(
    'pj:productPageUXFeedbackTime',
    0
  );

  const ONE_DAY = 86400 * 1000;

  const showUXFeedback = useShowFeedback(
    0.5,
    ONE_DAY * 7,
    productPageUXFeedbackTime
  );

  // Only show the prompt in supported markets
  if (!['se'].includes(market.code)) {
    return null;
  }

  if (!showUXFeedback) return null;

  return (
    <FeedbackPrompt
      formId="productPageUUPFeedback"
      storageId="pj:productPageUXFeedbackTime"
      title={t('product', 'uup.prompt-title')}
      description={t('product', 'uup.prompt-description')}
      utilityTitle={t('product', 'uup.question-utility')}
      usabilityTitle={t('product', 'uup.question-usability')}
      presentationTitle={t('product', 'uup.question-presentation')}
    />
  );
};

const FeedbackPrompt = styled(UXFeedbackPrompt)`
  display: inline-flex;
  background: none;
  padding: 0;
  width: 100%;

  ${media.smallOnly`
    margin-left: 0;
    margin-right: 0;
  `}
`;
